/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AssistantMCPServerRef,
  AssistantMCPServerRef$Outbound,
  AssistantMCPServerRef$outboundSchema,
} from "./assistantmcpserverref.js";
import {
  AssistantToolsetRef,
  AssistantToolsetRef$Outbound,
  AssistantToolsetRef$outboundSchema,
} from "./assistanttoolsetref.js";

/**
 * The assistant status.
 */
export const UpdateAssistantFormStatus = {
  Active: "active",
  Paused: "paused",
} as const;
/**
 * The assistant status.
 */
export type UpdateAssistantFormStatus = ClosedEnum<
  typeof UpdateAssistantFormStatus
>;

export type UpdateAssistantForm = {
  /**
   * The assistant ID.
   */
  id: string;
  /**
   * The system instructions for the assistant.
   */
  instructions?: string | undefined;
  /**
   * Maximum active warm runtimes.
   */
  maxConcurrency?: number | undefined;
  /**
   * MCP servers to attach. When sent, replaces the assistant's servers that are not hosted (toolset-backed). A hosted server listed here is attached if it is not already; attached hosted servers are left unchanged, and toolsets governs them when both are sent.
   */
  mcpServers?: Array<AssistantMCPServerRef> | undefined;
  /**
   * The model identifier used by the assistant.
   */
  model?: string | undefined;
  /**
   * The assistant name.
   */
  name?: string | undefined;
  /**
   * The assistant status.
   */
  status?: UpdateAssistantFormStatus | undefined;
  /**
   * Hosted (toolset-backed) MCP servers to attach, by toolset slug. When sent, replaces the assistant's hosted servers.
   */
  toolsets?: Array<AssistantToolsetRef> | undefined;
  /**
   * Warm runtime TTL in seconds.
   */
  warmTtlSeconds?: number | undefined;
};

/** @internal */
export const UpdateAssistantFormStatus$outboundSchema: z.ZodMiniEnum<
  typeof UpdateAssistantFormStatus
> = z.enum(UpdateAssistantFormStatus);

/** @internal */
export type UpdateAssistantForm$Outbound = {
  id: string;
  instructions?: string | undefined;
  max_concurrency?: number | undefined;
  mcp_servers?: Array<AssistantMCPServerRef$Outbound> | undefined;
  model?: string | undefined;
  name?: string | undefined;
  status?: string | undefined;
  toolsets?: Array<AssistantToolsetRef$Outbound> | undefined;
  warm_ttl_seconds?: number | undefined;
};

/** @internal */
export const UpdateAssistantForm$outboundSchema: z.ZodMiniType<
  UpdateAssistantForm$Outbound,
  UpdateAssistantForm
> = z.pipe(
  z.object({
    id: z.string(),
    instructions: z.optional(z.string()),
    maxConcurrency: z.optional(z.int()),
    mcpServers: z.optional(z.array(AssistantMCPServerRef$outboundSchema)),
    model: z.optional(z.string()),
    name: z.optional(z.string()),
    status: z.optional(UpdateAssistantFormStatus$outboundSchema),
    toolsets: z.optional(z.array(AssistantToolsetRef$outboundSchema)),
    warmTtlSeconds: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      maxConcurrency: "max_concurrency",
      mcpServers: "mcp_servers",
      warmTtlSeconds: "warm_ttl_seconds",
    });
  }),
);

export function updateAssistantFormToJSON(
  updateAssistantForm: UpdateAssistantForm,
): string {
  return JSON.stringify(
    UpdateAssistantForm$outboundSchema.parse(updateAssistantForm),
  );
}
